import e from "react";
import { useTheme as f, useMediaQuery as p, Box as o, Typography as g, Button as y, Divider as b } from "@mui/material";
import { c as x } from "./chunk.BDpTQ-W3.js";
function v() {
  return (/* @__PURE__ */ new Date()).getUTCFullYear();
}
const t = {
  privacyNotice: {
    key: "privacy-notice",
    buttonText: "Global Privacy Notice",
    href: "https://www.chrobinson.com/en-us/privacy-notice/"
  },
  privacyRights: {
    key: "privacy-rights",
    buttonText: "Your Privacy Rights",
    href: "https://www.chrobinson.com/en-us/your-privacy-rights/"
  },
  termsOfUse: {
    key: "terms",
    buttonText: "Terms of Use",
    href: "https://www.chrobinson.com/en-us/terms-of-use/"
  }
};
function E({
  disclaimerText: s,
  maxWidth: u = !0
}) {
  const n = f(), c = p(n.breakpoints.down("sm")), r = p(n.breakpoints.down("md")), l = [
    {
      ...t.privacyNotice,
      buttonText: t.privacyNotice.buttonText
    },
    {
      ...t.privacyRights,
      buttonText: t.privacyRights.buttonText
    },
    {
      ...t.termsOfUse,
      buttonText: t.termsOfUse.buttonText
    }
  ];
  let m = `© 1996-${v()} C.H. Robinson Wordwide, Inc. All rights reserved.`;
  s && (m += `
` + s.replace(/&#10;|\\n/g, `
`));
  const i = {
    px: n.spacing(6)
  };
  return u && (i.maxWidth = `calc(${n.breakpoints.values.xl}px - ${n.spacing(12)})`, i.margin = "auto"), /* @__PURE__ */ e.createElement(o, { sx: i, boxSizing: "content-box" }, !r && /* @__PURE__ */ e.createElement(o, { mb: 2 }, /* @__PURE__ */ e.createElement(
    "img",
    {
      src: x,
      alt: "C.H. Robinson Logo",
      title: "C.H. Robinson Logo",
      width: "174",
      height: "40"
    }
  )), /* @__PURE__ */ e.createElement(
    o,
    {
      display: "flex",
      flexDirection: r ? "column" : "row",
      justifyContent: "space-between",
      alignItems: r ? "center" : "last baseline",
      gap: r ? 2 : 3
    },
    /* @__PURE__ */ e.createElement(
      g,
      {
        variant: "caption",
        align: r ? "center" : void 0,
        whiteSpace: "pre-line"
      },
      m
    ),
    /* @__PURE__ */ e.createElement(
      o,
      {
        display: "flex",
        flexDirection: c ? "column" : "row",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 1
      },
      l.map((a, h) => /* @__PURE__ */ e.createElement(e.Fragment, { key: a.key }, /* @__PURE__ */ e.createElement(y, { variant: "text", href: a.href }, a.buttonText), !c && h < l.length - 1 && /* @__PURE__ */ e.createElement(
        b,
        {
          orientation: "vertical",
          variant: "middle",
          flexItem: !0
        }
      )))
    )
  ));
}
export {
  E as F
};
